// extracted by mini-css-extract-plugin
export var sliderRange = "_nu-2";
export var sliderRoot = "_nu-0";
export var sliderThumb = "_nu-3";
export var sliderTrack = "_nu-1";